FilesIndexNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryFileSort"
    - $ref: "../parameters.yaml#/QueryLimit"
    - $ref: "../parameters.yaml#/QueryOffset"
    - $ref: "../parameters.yaml#/QueryLanguage"
  
  get:
    operationId: getFilesIndexNode
    tags:
      - File
    summary: ファイルの照会
    description: |
      ### 指定フォルダ配下のファイルリストを照会します。
      
      DirectCloudのファイルにアクセスします。

      `node`は照会対象ファイルが存在するフォルダの識別コードです。

      `sort`は並び替えのことで、デフォルトはファイル名の昇順です。

      `size_text`はファイルのサイズを単位に合わせて処理した値(KB、MB、GBに換算)です。
      
      ### lastpage
      すべてのファイルの数とlimit、offsetの合算を比較し、最終ページの有無をお知らせします。
      - true: 最終ページ
      - false: 途中のページ
      
      ### limit, offset
      limitとoffsetはページング処理時に使用ください。
      
      ### 例) 1ページに200件出力する場合の「limit」と「offset」の設定
      - 1ページ ▶︎ limit=200 / offset=0
      - 2ページ ▶︎ limit=200 / offset=200
      - 3ページ ▶︎ limit=200 / offset=400

    security:
      - AccessToken: [ ]
    
    responses:
      "200":
        description: ファイル照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/GetFiles"
      "default":
        description: ファイル照会失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"

FilesIndexNodeFileSeq:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/PathFileSeq"
    - $ref: "../parameters.yaml#/QueryLanguage"

  get:
    operationId: getFilesIndexNodeFileSeq
    tags:
      - File
    summary: ファイル情報の取得
    description: |
      ### 特定ファイルの情報を取得します。
      
      `node`は情報取得対象ファイルが存在するフォルダの識別コードです。
      
    security:
      - AccessToken: [ ]
    
    responses:
      "200":
        description: ファイル情報取得成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/FileInfo"
      "default":
        description: ファイル情報取得失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"

getFilesCompressNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/CompressedFileSeqOptional"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: getFilesCompressNode
    tags:
      - File
    summary: 複数ファイルのダウンロード
    description: |
      ### 複数のファイルをダウンロードします。
      
      `node`はダウンロード対象ファイルが存在するフォルダの識別コードです。
      
      レスポンスで取得したダウンロードURLにアクセスすることで、ZIP形式で圧縮された複数のファイルをダウンロードできます。
      
      複数のファイルのfile_seqを半角のカンマ（,）で区切り、パラメータに指定してダウンロードすることもできます。
      
      リクエスト時、以下にあてはまると、エラーが発生します。
      
      - ファイルの合計容量が2GBを超過した場合
      
      - ダウンロードの権限がない場合

    security:
      - AccessToken: [ ]

    responses:
      "200":
        description: ファイルダウンロード成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/CompressedLinkInfo"
      "default":
        description: ファイルダウンロード失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              File Or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FileOrDirectoryNotExists"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionFileCompress"
              Exceeding the permitted size:
                $ref: "../openapi/response.error.yaml#/ExceedingThePermittedSize"

FilesUploadNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: postFilesUploadNode
    tags:
      - File
    summary: ファイルのアップロード
    description: |
      ### 指定のフォルダにファイルをアップロードします。
      `node`はファイルアップロード先フォルダの識別コードです。
      
       ファイルは管理者機能で設定した最大サイズまでアップロード可能です。(最大5GBまで)
      
       > 💡 &nbsp; **Note**  <br><br>
       **Case-sensitive**  
       パラメータ名は大文字・小文字を区分していますのでご注意ください。 <br><br>
       **ファイル名が重複した場合**
       アップロード先のフォルダに同名のファイルが存在する場合は上書きされ、管理者機能のバージョン管理設定に基づき履歴管理されます。

    security:
      - AccessToken: [ ]
    
    requestBody:
      $ref: "../openapi/requests.yaml#/UploadFileRequest"
    
    responses:
      "200":
        description: ファイルアップロード成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/UploadFile"
      "default":
        description: ファイルアップロードに失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              File Or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FileOrDirectoryNotExists"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfileu"

FilesRenameNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: postFilesRenameNode
    tags:
      - File
    summary: ファイル名の変更
    description: |
      ### ファイル名を変更します。

      `node`は名前変更対象のファイルが存在するフォルダの識別コードです。変更後のファイル名と同名のファイルが存在する場合はエラー処理されます。
      
    security:
      - AccessToken: [ ]
    
    requestBody:
      $ref: "../openapi/requests.yaml#/RenameFileRequest"
    
    responses:
      "200":
        description: ファイル名変更成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: ファイル名変更失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              File Or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FileOrDirectoryNotExists"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfilef"
              File Name Already Exists:
                $ref: "../openapi/response.error.yaml#/FileNameAlreadyExists"

FilesDownloadNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: postFilesDownloadNode
    tags:
      - File
    summary: ファイルのダウンロード
    description: |
      ### ファイルをダウンロードします。

      `node`はダウンロード対象ファイルが存在するフォルダの識別コードです。
      
      > 💡 &nbsp; **Note**  <br><br>
      **flag_direct**  
      flag_direct=Yを指定した場合は、API応答ではなくファイルバイナリデータをダウンロードします。
      **download_url**  
      ファイルのdownload_urlは1分間のみ有効で、1分後に無効になります。

    security:
      - AccessToken: [ ]
    
    requestBody:
      $ref: "../openapi/requests.yaml#/DownloadFileRequest"
    
    responses:
      "200":
        description: ファイルダウンロード成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/DownloadFile"
      "default":
        description: ファイルダウンロードに失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              File Or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FileOrDirectoryNotExists"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfiledown"

FilesDeleteNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: postFilesDeleteNode
    tags:
      - File
    summary: ファイルの削除
    description: |
      ### ファイルを削除します。

      `node`は削除対象のファイルが格納されているフォルダです。

      複数ファイルの削除が可能です。 削除されたファイルは、ユーザーのゴミ箱・管理者のゴミ箱の保存期間内であれば復元することができます。
      
      > 💡 &nbsp; **Note**  <br><br>
      ロック設定が行われたファイルは削除できない場合があります。

    security:
      - AccessToken: [ ]
    
    requestBody:
      $ref: "../openapi/requests.yaml#/DeleteFileRequest"
    
    responses:
      "200":
        description: ファイル削除成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: ファイル削除失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              File Or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FileOrDirectoryNotExists"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfiledel"

FilesMoveNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: postFilesMoveNode
    tags:
      - File
    summary: ファイルの移動
    description: |
      ### ファイルを移動します。
      
      `node`は移動対象ファイルが存在するフォルダの識別コードです。
      
      fids: {file_seq}|{node}

      `{ファイルの固有キー}|{ノード}` の形式で指定します。
        - file_seq: ファイル識別コード
        - node: 移動先のフォルダのノード

    security:
      - AccessToken: [ ]
    
    requestBody:
      $ref: "../openapi/requests.yaml#/MoveFileRequest"
    
    responses:
      "200":
        description: ファイル移動成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: ファイル移動失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              File Or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FileOrFolderNotExists"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfilem"

FilesSearchNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: postFilesSearchNode
    tags:
      - File
    summary: ファイルの検索
    description: |
      ### 指定のフォルダに存在するファイルを検索します。

      `node`は検索対象フォルダの識別コードです。
      `size_text`はファイルサイズを単位に合わせて処理した値(KB、MB、GBに換算)です。
      
      ### lastpage   
      すべてのファイル数とlimit、offsetの合計を比較して、最終ページかどうかを知らせます。
      - true: 最終ページ
      - false: 途中のページ

    security:
      - AccessToken: [ ]
    
    requestBody:
      $ref: "../openapi/requests.yaml#/SearchFileRequest"
    
    responses:
      "200":
        description: ファイル検索成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/SearchFile"
      "default":
        description: ファイル検索失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfiles"
